import type { MapTool } from '~/_shared/types/toolsAndFeatures/mapTools.types';
import { useSelector } from '~/_shared/utils/hooks/useSelector';
import type { AppState } from '~/store/app.store';
import { defaultSplitPanelItem } from '~/store/userData/settings/userDataSettings.reducer';

export const userDataSettingsSelector = (state: AppState) => state.userData.settings;
export const useUserDataSettingsSelector = () => useSelector(userDataSettingsSelector);

export const userDataIsReadySelector = (state: AppState) => state.userData.isReady;

export const useSplitItemSettingsSelector = (clientId: number | null, mapId: number | null) => {
  const userDataSettingsState = useSelector(userDataSettingsSelector);

  if (clientId === null || mapId === null) {
    return defaultSplitPanelItem;
  }

  const splitPanelState = userDataSettingsState?.[clientId]?.splitPanel;

  if (!splitPanelState) {
    return defaultSplitPanelItem;
  }

  return splitPanelState[mapId] ?? defaultSplitPanelItem;
};

export const useUserDataSettingsToolCollapseSelector = (clientId: number | null, mapId: number | null, mapTool: MapTool | null) => {
  const userDataSettingsState = useUserDataSettingsSelector();

  if (!clientId || !mapId || !mapTool) {
    return undefined;
  }

  return userDataSettingsState?.[clientId]?.toolsCollapse?.[mapId]?.[mapTool];
};

export const useUserSettingsIsBoundaryEditAllowed = (clientId: number | null) => {
  const userDataSettingsState = useUserDataSettingsSelector();

  return clientId === null ? false : userDataSettingsState?.[clientId]?.allowEditingBoundaryGroups ?? false;
};

export const useUserSettingsConfirmedMigrationWarning = (clientId: number | null) => {
  const userDataSettingsState = useUserDataSettingsSelector();

  return clientId === null ? false : userDataSettingsState?.[clientId]?.confirmedMigrationWarning ?? false;
};
